module.exports = __webpack_public_path__ + "img/Puente_Istobal_MNEX22_Alto_Blanco-default-front.228769e0.jpg";